export const defaultSettings = {
  'notification.activity.assigned': '1',
  'notification.activity.deleted': '1',
  'notification.company.deleted': '1',
  'notification.person.deleted': '1',
  'notification.project.statusChanged': '1',
  'notification.project.leaderAssigned': '1',
  'notification.project.leaderUnassigned': '1',
  'notification.project.deleted': '1',
  'notification.task.assigned': '1',
  'notification.task.done': '1',
  'notification.task.doneDelegated': '1',
  'notification.task.deleted': '1',
  'notification.task.deletedDelegated': '1',
  'notification.task.commented': '1',
  'notification.staff.joined': '1',
};

export default defaultSettings;



// WEBPACK FOOTER //
// ./src/config/defaultSettings.js